import { EntityLink } from 'rfa-react-core';
import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { truncateOnWordBoundary } from 'app/utilities/truncate';
import { metaTime, publishedTime } from 'app/utilities/date-time';

const CHARACTER_LIMIT = {
    DESCRIPTION: 140,
    TITLE: 90
};

const SLIDER_CONFIG = {
    adaptiveHeight: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    draggable: true,
    infinite: true,
    pauseOnHover: true,
    speed: 600,
    swipe: true,
    swipeToSlide: true,
    touchThreshold: 10
};

class FeaturedNewsCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.slider = null;
    }

    renderSlide(item, index) {
        const {
            author,
            name,
            publish_at: publishDate,
            short_description: description,
            thumbnail
        } = item.data;

        return (
            <div key={index} className="featured-news-carousel-slide">
                <EntityLink
                    item={item}
                    promoterBuName="Auckland Zoo"
                    className="featured-news-carousel-link"
                >
                    {/*
                        The largest image on the page and the one most worth having
                        in image search, so it is an element with the headline as
                        its description rather than a background.

                        The first slide is what the reader lands on, so it is left
                        to load at the normal priority; the ones behind it are held
                        back until the carousel reaches them.
                    */}
                    {thumbnail ?
                        <img
                            className="featured-news-carousel-image"
                            src={thumbnail}
                            alt={name}
                            loading={index === 0 ? 'eager' : 'lazy'}
                            decoding="async"
                        /> :
                        <div className="featured-news-carousel-image is-placeholder" />
                    }
                    <div className="featured-news-carousel-content">
                        <h1 className="title">{truncateOnWordBoundary(name, CHARACTER_LIMIT.TITLE)}</h1>
                        {description &&
                            <p className="subtitle">
                                {truncateOnWordBoundary(description, CHARACTER_LIMIT.DESCRIPTION)}
                            </p>
                        }
                        <p className="meta">
                            {author && <span className="author">by {author}</span>}
                            {publishDate && <br />}
                            {publishDate && <time dateTime={metaTime(publishDate)}>{publishedTime(publishDate)}</time>}
                        </p>
                    </div>
                </EntityLink>
            </div>
        );
    }

    renderControls() {
        return (
            <div className="featured-news-carousel-controls">
                <button
                    className="change-slide previous"
                    aria-label="Previous story"
                    onClick={() => this.slider && this.slider.slickPrev()}
                >
                    <Icon name="chevron" title="Previous" />
                </button>
                <button
                    className="change-slide next"
                    aria-label="Next story"
                    onClick={() => this.slider && this.slider.slickNext()}
                >
                    <Icon name="chevron" title="Next" />
                </button>
            </div>
        );
    }

    render() {
        const { items } = this.props;

        if (!items || !items.length) return null;

        // A single slide does not need the slider chrome
        if (items.length === 1) {
            return (
                <div className="featured-news-carousel">
                    {this.renderSlide(items[0], 0)}
                </div>
            );
        }

        return (
            <div className="featured-news-carousel">
                <Slider ref={(slider) => { this.slider = slider; }} {...SLIDER_CONFIG}>
                    {items.map((item, index) => this.renderSlide(item, index))}
                </Slider>
                {this.renderControls()}
            </div>
        );
    }
}

FeaturedNewsCarousel.propTypes = {
    items: PropTypes.array
};

export default FeaturedNewsCarousel;
